import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';

import Slides from '@ifeng-fe/ui_pc_slides';

import { formatImage } from '@ifeng-fe/public_method';

import { Poster } from '../../../../components/modal';

class AreaReports extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    handleClick = item => {
        if (item) {
            Poster.show({ content: <img src={item.image} title={item.desc} /> });
        }
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        // eslint-disable-next-line consistent-this
        const that = this;

        const sliderTmpl = function sliderTmpl(item, show, index) {
            // console.log(item, index);

            return (
                <div className={styles.slideItem}>
                    {item.map((_item, _index) => (
                        <div
                            onClick={() => that.handleClick(_item)}
                            className={styles.sonItem}
                            key={_index}
                            style={{ marginRight: _index === item.length - 1 ? 0 : 10 }}>
                            <img src={_item.image ? formatImage(_item.image, 242, 134) : ''} title={_item.desc} />
                        </div>
                    ))}
                </div>
            );
        };

        const list = [];

        if (content && content.length) {
            const count = Math.ceil(content.length / 4);

            for (let i = 0; i < count; i++) {
                list.push(content.slice(4 * i, 4 * i + 4));
            }
        }

        // console.log(list);

        const sliderConfig = {
            arrows: true,
            autoplay: false,
            dots: false,
            dotsAction: 'hover',
            direction: 'forward',
            pauseOnHover: true,
            autoplayInterval: 5000,
            axis: 'horizonta',
            initialSlide: 0,
            unitSize: 1000,
            speed: 500,
            infinite: true,
            sliderTmpl,
        };

        return (
            <div className={styles.slides}>
                <Slides content={list} config={sliderConfig} />
            </div>
        );
    }
}

export default errorBoundary(AreaReports);
